<template>
    <rkm-modal
        :loading="loading"
        large
        ref="Modal"
        persistent
        title="Materiais"
    >
        <rkm-area title="Materiais">
            <rkm-table
                :fields="fields"
                :items="materiais"
                @filtered="materiaisFiltered = $event"
            >
                <template v-slot:cell(dispensar)="{ item }">
                    <rkm-form-checkbox
                        v-model="item.dispensar"
                    />
                </template>
            </rkm-table>
        </rkm-area>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'dispensar',
                    class: 'col-min text-center'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                },
            ]
        },
    },
    data: () => ({
        grupoId: null,
        materiais: [],
        materiaisFiltered: [],
    }),
    methods: {
        open(grupo) {
            this.grupoId = grupo.id
            this.materiais = this.clone(grupo.materiais)
            this.materiaisFiltered = this.clone(this.materiais)

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        save() {
            let index = this.data.grupos.findIndex(grupo => grupo.id == this.grupoId)
            if(this.materiais.every(material => material.dispensar)) {
                this.data.grupos[index].dispensar = true
            }
            if(this.materiais.every(material => !material.dispensar)) {
                this.data.grupos[index].dispensar = false
            }
            this.data.grupos[index].materiais = this.materiais
            this.$refs.Modal.hide()
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    }
}
</script>